import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axiosInstance from '../utils/axiosInstance';
import { useNavigate, useParams } from 'react-router-dom';
import { config } from '../utils';

const EditOfficer = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchOfficerDetails();// eslint-disable-next-line
    }, [id]);

    const fetchOfficerDetails = async () => {
        try {
            const response = await axiosInstance.get(`${config.api.endpoints.officers}/${id}`);
            form.setFieldsValue({
                officer_name: response.data.officer_name,
                email: response.data.email,
                phone_number: response.data.phone_number,
                // Note: For image, we need to handle differently
            });
        } catch (error: any) {
            console.error('Error fetching officer details:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            }
            message.error('Failed to fetch officer details');
        }
    };

    const onFinish = async (values: any) => {
        setLoading(true);

        const formData = new FormData();
        if (values.officer_name) formData.append('officer_name', values.officer_name);
        if (values.email) formData.append('email', values.email);
        if (values.phone_number) formData.append('phone_number', values.phone_number);

        if (values.img && values.img.fileList.length > 0) {
            formData.append('img', values.img.fileList[0].originFileObj);
        }

        try {
            await axiosInstance.put(`${config.api.endpoints.officers}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            message.success('Officer updated successfully');
            navigate('/officers');
        } catch (error: any) {
            console.error('Error updating officer:', error);
            if (error.response && error.response.data.detail) {
                message.error(error.response.data.detail);
            } else {
                message.error('Failed to update officer');
            }
        } finally {
            setLoading(false);
        }
    };

    // Helper function to normalize the file input
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    return (
        <div className="p-8">
            <h1 className="text-2xl font-bold mb-6">Edit Officer</h1>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                {/* Officer Name */}
                <Form.Item label="Officer Name" name="officer_name">
                    <Input placeholder="Enter officer's name" />
                </Form.Item>

                {/* Email */}
                <Form.Item label="Email" name="email">
                    <Input placeholder="Enter email" />
                </Form.Item>

                {/* Phone Number */}
                <Form.Item label="Phone Number" name="phone_number">
                    <Input placeholder="Enter phone number" />
                </Form.Item>

                {/* Profile Image */}
                <Form.Item
                    label="Profile Image"
                    name="img"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                >
                    <Upload
                        listType="picture"
                        maxCount={1}
                        beforeUpload={() => false} // Prevent automatic upload
                    >
                        <Button icon={<UploadOutlined />}>Upload New Profile Image</Button>
                    </Upload>
                </Form.Item>

                {/* Submit Button */}
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Update Officer
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default EditOfficer;